import { Box, Typography } from '@mui/material';
import cx from 'clsx';
import Image from 'next/image';

import styles from './Avatar.module.scss';

type AvatarColor = 'pink' | 'green' | 'blue' | 'white' | 'orange';

interface AvatarProps {
  name: string;
  role?: string;
  image?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const getColorByName = (name: string): AvatarColor => {
  const firstName = name.trim().split(/\s+/)[0].toLowerCase();

  if (firstName === 'ivan') return 'blue';

  if (firstName === 'ante') return 'orange';

  if (firstName === 'luka') return 'green';

  if (firstName === 'toni') return 'pink';

  if (firstName === 'roko') return 'white';

  return 'blue';
};

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);

  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const sizeMap = {
  sm: 32,
  md: 40,
  lg: 56,
  xl: 64,
};

const Avatar = ({ name, image, size = 'md', className }: AvatarProps) => {
  const colorClass = getColorByName(name);
  const initials = getInitials(name);
  const retinaSize = sizeMap[size] * 3;

  return (
    <Box className={cx(styles.avatar, styles[size], styles[colorClass], className)}>
      {image ? (
        <Image src={image} alt={name} fill className={styles.image} sizes={`${retinaSize}px`} />
      ) : (
        <Typography className={styles.initials}>{initials}</Typography>
      )}
    </Box>
  );
};

export default Avatar;
